import React from 'react';

import styles from './styles.module.css';

export const Preloader = () => (
  <div className={styles.wrapper}>
    <div className={styles.spinner} />
  </div>
);
